/*
 * gift-ux-fix.js  —  Schacht Groves Citrus
 * Theme-level enhancement layered over the Gift Ship app embed.
 *
 *   #3  Gift Ship renders TWO gift-message field sets (one gated behind the
 *       "Is this a gift?" checkbox, one always-visible). They submit the same
 *       properties[To/From/Message] names and collide, and confuse buyers.
 *       -> We neutralise the always-visible duplicate, keeping the gated set.
 *   #4  The gift message is optional, so buyers skip it and email later.
 *       -> We require the message when "Is this a gift?" is checked, enforced
 *          at the /cart/add fetch (Horizon adds to cart via AJAX), so the item
 *          cannot enter the cart without a message.
 *
 * Defensive: Gift Ship renders asynchronously and re-renders on variant change,
 * so we (re)apply on a MutationObserver and mark processed nodes.
 */
(function () {
  'use strict';

  var PROCESSED = 'data-gux-processed';
  var NAMES = ['To', 'From', 'Message'];
  var ERR_MSG = 'Please add a gift message so we can include it with your gift.';

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    var s = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && s.display !== 'none' && s.visibility !== 'hidden' && el.offsetParent !== null;
  }

  function neutralise(field) {
    if (!field || field.getAttribute(PROCESSED) === 'removed') return;
    field.setAttribute(PROCESSED, 'removed');
    field.disabled = true;                 // disabled controls are not submitted -> no collision
    field.dataset.guxName = field.name || '';
    field.removeAttribute('name');         // belt & suspenders: no duplicate property key
    var wrap = field.closest('.gs__product-element') || field;
    wrap.style.setProperty('display', 'none', 'important');
  }

  // The kept (gated) message field within a form, live-queried.
  function keptMessage(form) {
    return (form || document).querySelector('[name="properties[Message]"]:not([disabled])');
  }
  function giftCheckbox(form) {
    return (form || document).querySelector('input[name="properties[gift]"], .gs__gift-checkbox input[type="checkbox"]');
  }

  function dedupe(form) {
    var cb = giftCheckbox(form);
    var giftOn = cb && cb.checked;
    NAMES.forEach(function (name) {
      var fields = Array.prototype.slice.call(form.querySelectorAll('[name="properties[' + name + ']"]'));
      if (fields.length < 2) return;
      var gated = fields.filter(function (f) { return f.closest('.gs__option'); });
      var toRemove;
      if (gated.length && gated.length < fields.length) {
        toRemove = fields.filter(function (f) { return !f.closest('.gs__option'); });
      } else if (!giftOn) {
        var visible = fields.filter(isVisible);
        var hidden = fields.filter(function (f) { return !isVisible(f); });
        toRemove = (visible.length && hidden.length) ? visible : fields.slice(1);
      } else {
        toRemove = fields.slice(1);
      }
      toRemove.forEach(neutralise);
    });
  }

  function showError(field) {
    if (!field) return;
    field.setAttribute('aria-invalid', 'true');
    field.style.outline = '2px solid #c0392b';
    var id = 'gux-error-msg';
    var err = document.getElementById(id);
    if (!err) {
      err = document.createElement('div');
      err.id = id;
      err.className = 'gux-error';
      err.setAttribute('role', 'alert');
      err.style.cssText = 'color:#c0392b;font-size:0.85rem;margin-top:6px;line-height:1.3;';
      field.insertAdjacentElement('afterend', err);
    }
    err.textContent = ERR_MSG;
    try { field.focus({ preventScroll: true }); } catch (e) {}
    field.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function clearError(field) {
    var err = document.getElementById('gux-error-msg');
    if (err) err.remove();
    if (field) { field.removeAttribute('aria-invalid'); field.style.outline = ''; }
  }

  // Is any product form currently a gift-with-empty-message? If so, surface the error.
  function giftMessageMissing() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var cb = giftCheckbox(forms[i]);
      if (!(cb && cb.checked)) continue;
      var msg = keptMessage(forms[i]);
      if (msg && !msg.value.trim()) { showError(msg); return true; }
    }
    return false;
  }

  // ---- #4 enforcement: intercept the AJAX add-to-cart ----
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?(\?|#|$)/.test(url) && giftMessageMissing()) {
        // Return a Shopify-style 422 so the theme shows the error and does NOT add.
        var body = JSON.stringify({ status: 422, message: 'Gift message required', description: ERR_MSG });
        return Promise.resolve(new Response(body, {
          status: 422,
          statusText: 'Unprocessable Entity',
          headers: { 'Content-Type': 'application/json' }
        }));
      }
    } catch (e) { /* never break checkout on our account */ }
    return nativeFetch.apply(this, arguments);
  };

  function enhance() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      if (!form.querySelector('[class*="gs__"]')) return;
      dedupe(form);
      if (!form.__guxInput) {
        form.__guxInput = true;
        form.addEventListener('input', function (e) {
          if (e.target && e.target.name === 'properties[Message]') clearError(e.target);
        });
      }
    });
  }

  function boot() {
    enhance();
    new MutationObserver(function () { enhance(); }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
